import { TaskStatus, TaskRootStatus, TeamTaskSubtaskDTO } from "shared/services";

export type TaskBoardFilterStatus = "all" | TaskStatus;

export interface TaskNode {
	id: string;
	teamId: string;
	workspaceId: string;
	accountId: string;
	objective: string;
	systemPrompt: string;
	status: TaskRootStatus;
	cancelledAt: string | null;
	cancelledBy: string | null;
	cancellationReason: string | null;
	createdAt: string;
	updatedAt: string;
	itemIds: string[];
}

export interface TaskItemNode {
	id: string;
	taskId: string;
	title: string;
	description: string | null;
	objective: string;
	createdAt: string;
	updatedAt: string;
	subtaskIds: string[];
}

export interface SubtaskToolCallState {
	toolName: string;
	mcpSlug?: string;
	mcpName?: string;
	phase: "start" | "end";
	startedAt?: string;
	durationMs?: number;
	success?: boolean;
	error?: string;
}

export interface TaskBoardState {
	taskIds: string[];
	taskById: Record<string, TaskNode>;
	taskItemById: Record<string, TaskItemNode>;
	subtaskById: Record<string, TeamTaskSubtaskDTO>;
	toolCallBySubtaskId: Record<string, SubtaskToolCallState>;
	memberNamesById: Record<string, string>;
	selectedTaskId: string | null;
	loadingTasks: boolean;
	loadingMembers: boolean;
}

export interface SidebarTaskSummary {
	id: string;
	teamId: string;
	teamName: string;
	objective: string;
	updatedAt: string;
	totalItems: number;
	completedItems: number;
	searchBlob: string;
}

export interface SidebarTaskGroup {
	key: string;
	label: string;
	tasks: SidebarTaskSummary[];
}

export interface TaskItemAlertInfo {
	type: "error" | "info";
	label: string;
	value?: string;
}

export interface TaskItemViewModel {
	id: string;
	title: string;
	description: string;
	status: TaskStatus;
	statusLabel: string;
	progress: number;
	errorDescription: string | null;
	alerts: TaskItemAlertInfo[];
	activeMemberId: string | null;
	activeMemberName: string;
	teamName: string;
	startedAt: string | null;
	completedAt: string | null;
	durationMs: number | null;
	updatedAt: string;
}

export interface TaskStatusCounts {
	all: number;
	pending: number;
	processing: number;
	completed: number;
	failed: number;
	paused: number;
	cancelled: number;
}

export interface TaskHeaderStats {
	completedToday: number;
	processing: number;
	waiting: number;
	failed: number;
}

export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
	pending: "Pendente",
	processing: "Executando",
	completed: "Concluída",
	failed: "Erro",
	paused: "Pausada",
	cancelled: "Cancelada",
};
